import Axios2 from "@/utils/Axios2";

/**
 * 打开处置弹窗
 */
export function openDisposePopup(context) {
  resetDisposePopup(context);
  context.showDisposePopup = true;
}

/**
 * 重置处置弹窗
 */
export function resetDisposePopup(context) {
  context.disposeForm = {
    disposerName: '',
    disposeTime: '',
    riskLevels: [],
    disposeContent: ''
  };
  context.disposePhotos = [];
  context.disposePhotoPaths = [];
  context.disposePhotoThumbnailPaths = [];
}

/**
 * 处置照片上传前校验
 */
export function beforeDisposeUpload(context, file) {
  const isPicture = file.type === 'image/jpeg' || file.type === 'image/png';
  const pictureSize = file.size < 10 * 1024 * 1024;
  if (!isPicture) {
    context.$message.error('只能上传 JPG/PNG 格式的图片');
    return false;
  }
  if (!pictureSize) {
    context.$message.error('只能上传 10MB 以内大小的图片');
    return false;
  }
  if (context.disposePhotos.length >= 9) {
    context.$message.warning('最多只能上传9张照片');
    return false;
  }
  return true;
}

/**
 * 自定义上传处置照片
 */
export function customDisposeUpload(context, { file }) {
  context.isDisposeUploading = true;
  const formData = new FormData();
  formData.append('file', file);
  const param = {
    method: 'post',
    url: '/api/v1/monitor/dispose/uploadPicture',
    data: formData
  };
  return Axios2.ajax(param)
    .then((res) => {
      if (res.code === 0 && res.data) {
        if (context.disposePhotos.length >= 9) {
          context.$message.warning('最多只能上传9张照片');
          return;
        }
        const extractUrl = (str) => {
          const match = str.match(/https?:\/\/[^\s<]+/);
          return match ? match[0] : '';
        };
        context.disposePhotos.push(extractUrl(res.data.pictureUrl));
        context.disposePhotoPaths.push(res.data.picturePath);
        context.disposePhotoThumbnailPaths.push(res.data.thumbnailPath);
        context.$message.success('上传成功');
      } else {
        context.$message.error(res.message || '上传失败');
      }
    })
    .catch((err) => {
      console.error('上传请求失败：', err);
      context.$message.error('上传请求失败');
    })
    .finally(() => {
      context.isDisposeUploading = false;
    });
}

/**
 * 移除处置照片
 */
export function removeDisposePhoto(context, index) {
  context.disposePhotos.splice(index, 1);
  context.disposePhotoPaths.splice(index, 1);
  context.disposePhotoThumbnailPaths.splice(index, 1);
}

/**
 * 提交处置记录
 */
export function submitDispose(context) {
  const form = context.disposeForm;
  // 前端非空校验
  if (!form.disposerName || !form.disposerName.trim()) {
    context.$message.warning('请输入处置人名称');
    return Promise.reject();
  }
  if (!form.disposeTime) {
    context.$message.warning('请选择处置时间');
    return Promise.reject();
  }
  if (!form.riskLevels || form.riskLevels.length === 0) {
    context.$message.warning('请选择隐患等级');
    return Promise.reject();
  }
  if (!form.disposeContent || !form.disposeContent.trim()) {
    context.$message.warning('请输入处置内容');
    return Promise.reject();
  }

  context.isDisposeSubmitting = true;
  const param = {
    method: 'post',
    url: '/api/v1/monitor/dispose',
    data: {
      monitorSiteId: context.saveid,
      disposerName: form.disposerName.trim(),
      disposeTime: form.disposeTime,
      riskLevels: form.riskLevels,
      disposeContent: form.disposeContent.trim(),
      disposePhotoPath: context.disposePhotoPaths,
      disposePhotoThumbnailPath: context.disposePhotoThumbnailPaths
    }
  };

  return Axios2.ajax(param)
    .then((res) => {
      if (res.code === 0) {
        context.$message.success('处置记录提交成功');
        context.showDisposePopup = false;
        resetDisposePopup(context);
        // 刷新隐患列表和处置记录列表
        context.getRiskList();
        context.getriskTypeList();
        context.getDisposeList();
      } else {
        context.$message.error(res.msg || '提交失败');
      }
    })
    .catch((err) => {
      context.$message.error('提交失败：' + (err.message || '未知错误'));
    })
    .finally(() => {
      context.isDisposeSubmitting = false;
    });
}

/**
 * 查询处置记录列表
 */
export function getDisposeList(context) {
  const param = {
    method: 'get',
    url: '/api/v1/monitor/dispose/page',
    params: {
      monitorSiteId: context.saveid,
      pageNum: context.disposePageNum || 1,
      pageSize: 10
    }
  };
  return Axios2.ajax(param).then((res) => {
    if (res.code === 0 && res.data) {
      context.disposeRecordList = res.data.records || [];
      context.disposeRecordTotal = res.data.total || 0;
    }
  });
}

/**
 * 处置记录翻页
 */
export function disposePageChange(context, page) {
  context.disposePageNum = page;
  getDisposeList(context);
}

/**
 * 预览处置照片
 */
export function previewDisposePhoto(context, url) {
  if (url) {
    window.open(url, '_blank');
  } else {
    context.$message.warning('暂无照片');
  }
}
